var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-chart',{style:({ width: '100%', height: '100%' }),attrs:{"options":_vm.chartOptions,"autoresize":""},on:{"click":function($event){return _vm.handleClick($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }